export default __webpack_public_path__ + "static/media/TOEFL.4f34f8db.png";